// @flow
import {createReducer} from 'modules/redux/reducer';
import {SETTINGS_ACTION_TYPE} from 'modules/settings/constants';
import type {TCompanyData, TLastServerUpdate} from 'modules/settings/types';

export type TSetCompanyData = {
    payload: TCompanyData,
    type: typeof SETTINGS_ACTION_TYPE.SET_COMPANY_DATA,
};
export type TSetLastServerUpdate = {
    payload: TLastServerUpdate,
    type: typeof SETTINGS_ACTION_TYPE.SET_LAST_SERVER_UPDATE,
};
export type TSettingsState = {
    companyData: TCompanyData,
    lastServerUpdate: TLastServerUpdate,
};

export const initialState: TSettingsState = {
    companyData: {},
    lastServerUpdate: '',
};

const reducer = {
    [SETTINGS_ACTION_TYPE.SET_COMPANY_DATA]: (state, payload: TCompanyData) => {
        return {
            ...state,
            companyData: payload,
        };
    },
    [SETTINGS_ACTION_TYPE.SET_LAST_SERVER_UPDATE]: (state, payload: TLastServerUpdate) => {
        return {
            ...state,
            lastServerUpdate: payload,
        };
    },
};

export const settingsReducer = createReducer(initialState, reducer);
